module.exports = __webpack_public_path__ + "media/images/logos/navico-md-eca43bdb7284910318105cdd6b1bbf5d.png";